import script from "./SoccerScoreboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SoccerScoreboard.vue?vue&type=script&setup=true&lang=js"

import "./SoccerScoreboard.vue?vue&type=style&index=0&id=6e1c74db&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e1c74db"]])

export default __exports__